import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/tenant.query.gql"
import type {
  TenantQuery,
  TenantQueryVariables,
} from "@/v2-backoffice-client/tenant/__types__/tenant.query"

type Options = QueryHookOptions<TenantQuery, TenantQueryVariables>

export function useTenantQuery(options?: Options) {
  return useQuery<TenantQuery, TenantQueryVariables>(query, options)
}
